import React from 'react'
import { Grid, Container } from '@mui/material';
import Menu from '../../Menu/Menu.js'
import * as NeedfindingGameContent from './NeedfindingGameContent.js'
import './NeedfindingGame.css'
import '../Projects.css'
import MoreProjects from '../MoreProjects/MoreProjects.js'

function NeedfindingGame(props) {
  document.title = "NeedfindingGame — Eileen Chen";
  return (
    <>
      <Container className="project-content" maxWidth="xl">
        <Grid container columns={16} columnSpacing={12}>
          <Grid className="menuBlock" item sm={0} md={3}>
            <Menu menuItems={{
              BackToTop: null,
              Intro: null,
              Inspiration: null,
              Playtest1: null, 
              Playtest2: null,
              FinalPlaytest: null,
              LessonsNextSteps: null,
              }}></Menu>
          </Grid>
          <Grid item sm={16} md={13} sx={{pb:10}} data-aos="fade-up">
            <NeedfindingGameContent.Intro/>
            <NeedfindingGameContent.Inspiration/>
            <NeedfindingGameContent.Playtest1/>
            <NeedfindingGameContent.Playtest2/>
            <NeedfindingGameContent.FinalPlaytest/>
            <NeedfindingGameContent.LessonsNextSteps/>
          </Grid>
        </Grid>
      </Container>
      <MoreProjects relatedProjects={['Fitvio', 'CapitalOne', 'Weee']}/>
    </>
    
  )
}

export default NeedfindingGame